export default {
  name: 'Layout'
};